<template>
  <section>
    <b-overlay
      :show='loading'
      rounded
      no-center
      opacity='0.6'
      spinner-small
      spinner-variant='primary'
      class='d-inline-block w-100'
      style='min-height: 250px'
    >
      <section class="mb-3">
        <section class="filters">
          <section>
            <label>Data inicial</label>
            <b-form-input
              v-model="userAwareOfInformationMeta.startDate"
              placeholder="Data inicial"
              type="date"
            >
            </b-form-input>
          </section>

          <section>
            <label>Data final</label>
            <b-form-input
              v-model="userAwareOfInformationMeta.endDate"
              placeholder="Data final"
              type="date"
            >
            </b-form-input>
          </section>

          <section>
            <label>E-mail</label>
            <b-form-input
              v-model="userAwareOfInformationMeta.search"
              placeholder="E-mail"
              type="search"
            >
            </b-form-input>
          </section>
        </section>
        <section class="mt-3 d-flex justify-content-end">
          <section class="">
            <b-button @click="getPaginatedList(1)" variant="success">
              <b-icon
                icon='search'
                font-scale=".9"
                class="mr-1"
              >
              </b-icon>
              <span>Pesquisar</span>
            </b-button>

            <b-button @click="reset()" variant="info" class="ml-2">
              <b-icon
                icon='arrow-repeat'
                class="mr-1"
              >
              </b-icon>
              <span>Limpar filtros</span>
            </b-button>
          </section>
        </section>
      </section>

      <section>
        <base-table
          :columns='columns'
          :data='userAwareOfInformation'
          :total-items='userAwareOfInformationMeta.total'
          :start-items='userAwareOfInformationMeta.skip + 1'
          :max-items='userAwareOfInformationMeta.limit'
          @set-page='getPaginatedList'
        >
          <template v-slot:body-createdAt='row'>
            {{ row.item && row.item.createdAt && row.item.createdAt ? formatDate(row.item.createdAt) : '' }}
          </template>

          <template v-slot:body-user='row'>
            {{ row.item && row.item.user && row.item.user.username ? row.item.user.username : '-'}}
          </template>

          <template v-slot:body-awareOfInformation='row'>
            {{ row.item.awareOfInformation ? 'Sim' : 'Não'}}
          </template>

          <template v-slot:body-clickedContinue='row'>
            {{ row.item.clickedContinue ? 'Sim' : 'Não'}}
          </template>

          <template v-slot:body-location='row'>
            <b-tooltip :target='row.item._id' triggers='hover' placement='auto'>
              <view-json-file
                v-if='row.item.location'
                :file='row.item.location'
              ></view-json-file>

              <p v-else>-</p>
            </b-tooltip>

            <p :id='row.item._id' class='whatTheSearchReturned cursor-pointer'>
              Ver localização
            </p>
          </template>
        </base-table>
      </section>

      <template v-slot:overlay>
        <div class='text-center loading-spinner'>
          <b-spinner style='width: 3rem; height: 3rem;' variant='primary' label='Large Spinner'></b-spinner>
          <h5 class='text-primary'>Buscando...</h5>
        </div>
      </template>
    </b-overlay>
  </section>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import format from 'date-fns/esm/format/index'
import ViewJsonFile from '@/components/ViewJsonFile.vue'

export default {
  name: 'UserAwareOfInformationTable',
  data() {
    return {
      loading: false,
      description: '',
      title: '',
      webAppUserBond: Object,
      columns: [
        { key: 'user', value: 'Usuário' },
        { key: 'clickedContinue', value: 'Clicou em "Continuar"' },
        { key: 'awareOfInformation', value: 'Marcou "Não exibir novamente, mas estou ciente das informações e declaro estar de acordo."' },
        { key: 'createdAt', value: 'Data' },
        { key: 'location', value: 'Localização' },
      ]
    }
  },
  components: { ViewJsonFile },
  computed: {
    ...mapGetters('userAwareOfInformation', {
      userAwareOfInformation: 'userAwareOfInformation',
      userAwareOfInformationMeta: 'userAwareOfInformationMeta'
    })
  },
  watch: {},
  methods: {
    ...mapActions('breadcrumb', {
      setBreadcrumb: 'setBreadcrumb'
    }),
    ...mapActions('userAwareOfInformation', {
      handlePaginatedList: 'handlePaginatedList',
      handleResetMeta: 'handleResetMeta'
    }),
    async reset() {
      this.loading = true
      await this.handleResetMeta()
      await this.handlePaginatedList({})
      this.loading = false
    },

    async getPaginatedList(page) {
      try {
        this.loading = true
        const pageCount = page <= 0 ? 1 : page

        const params = {
          ...this.userAwareOfInformationMeta,
          skip: ((pageCount - 1) * this.userAwareOfInformationMeta.limit),
        }
        console.log(params)
        await this.handlePaginatedList(params)
        this.loading = false
      } catch (e) {

      }
    },

    formatDate(date) {
      return format(new Date(date), 'dd/MM/yyyy HH:mm:ss')
    }
  },
  async mounted() {
    this.loading = true
    await this.handlePaginatedList({})
    this.loading = false
  },
  async created() {
    const breadcrumb = {
      tab: '',
      page: 'Solicitação para vincular conta do HO Fácil Web com HOFácil App',
      subPage: {
        name: 'Solicitação para vincular conta do HO Fácil Web com HOFácil App',
        active: false
      },
      tabs: []
    }
    await this.setBreadcrumb(breadcrumb)
  }
}
</script>
<style lang='scss' scoped>
.pending {
  background: orange;
  padding: 5px 8px;
  border-radius: 6px;
  font-weight: 700;
}

.approved {
  background: #22C55E;
  padding: 5px 8px;
  border-radius: 6px;
  font-weight: 700;
}

.disapproved {
  background: #bc0000;
  padding: 5px 8px;
  border-radius: 6px;
  font-weight: 700;
}

.filters {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  section {
    width: 33%;
    min-width: 300px;
  }
}

</style>
